import { render, staticRenderFns } from "./StartupsStageColumnChart.vue?vue&type=template&id=91e259f0&"
import script from "./StartupsStageColumnChart.vue?vue&type=script&lang=js&"
export * from "./StartupsStageColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports